/**
 * THE אחריות TAB — the one the owner named.
 *
 * "if there's no warranty, don't have this tab at all in the product." This
 * component answers null for a warranty with neither a month count nor any
 * words, and the page uses the SAME emptiness test to leave the tab out — one
 * predicate, `hasWarranty`, so the tab and its panel can never disagree.
 *
 * The month count is a headline and the text is the rest, because those are
 * two different kinds of promise: "24 months" is checkable, and the prose says
 * what it covers. dk-store states no number at all — his one text names a year
 * for Daniel Klein watches and none for KOALA DESIGN jewellery, in the same
 * paragraph, because his plugin had no per-shelf level to say it on — so the
 * headline is simply absent rather than guessed at.
 */
import React from 'react';
import PolicyProse from './PolicyProse';
import PolicyDocumentLink from './PolicyDocumentLink';
import { warrantyLengthLabel } from '../../utils/shopPromises';
import styles from './styles.module.css';

const WarrantySection = ({ warranty, entry = null, t, isRtl, id }) => {
  // `warrantyForDisplay` already decided whose words these are and whether
  // there are any — one predicate for the tab and the panel, so the two can
  // never disagree about whether there is something in here.
  if (!warranty) return null;
  const { duration } = warranty;
  return (
    <div id={id} className={styles.warrantyBody} data-testid="product-detail-warranty">
      {duration && (
        <div className={styles.warrantyMonths} data-testid="product-detail-warranty-months">
          {warrantyLengthLabel(duration, t)}
        </div>
      )}
      <PolicyProse
        blurb={warranty.blurb}
        isRtl={isRtl}
        className={styles.policyProse}
        testId="product-detail-warranty-text"
      />
      {/* The full terms, when the shop attached a file to the SAVED warranty
        * that answered. Absent on the platform default: Stylon has no terms
        * document to hand out on a merchant's behalf. */}
      <PolicyDocumentLink entry={entry} t={t} testId="product-detail-warranty-document" />
    </div>
  );
};

export default WarrantySection;
